module.exports = __webpack_public_path__ + "static/media/project1.06fbf1a8.png";